<template>
  <zm-dialog class="opc-zod" title="" :visible.sync="visible_" width="30%" append-to-body show-close @closed="afterClose">
    <div class="opc-zod__head">
      <h2>{{ $t('billing.delta.cur_plan_details') }}</h2>
      <span>{{ plansCount }} {{ $t('billing.order_summary.item_ss') }}</span>
    </div>
    <PlanDetail ref="planDetail" :aware="planDetailAware"/>
    <div class="opc-zod__footer">
      <current-charge :modifier="currentChargeAmountModifier" />
    </div>
  </zm-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import Cart from '../cart.vue';
import CurrentCharge from '@/views/config/shopping-cart/current.vue';
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';
import { CART_DISPLAY_MODE } from '@/plans/mx/shopping-cart.vue';

const PlanDetail = {
  props: {
    aware: {
      type: Function,
      default: () => {}
    }
  },
  mixins: [Cart],
  computed: {
    ...mapGetters(['boughtPlans']),
    mimic() {
      let boughtPlansOfType = plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).get();
      let mode = CART_DISPLAY_MODE.BOUGHT;
      const plans = [];
      boughtPlansOfType.forEach((plan) => {
        if (!plan.ratePlans.length) {
          plans.push(plan);
        } else {
          // TODO this is on condition that it is single plan with ratePlans
          mode = CART_DISPLAY_MODE.SUM;
          plan.ratePlans.forEach((ratePlan) => {
            // lets mimic rate plans to be plain ones
            plans.push({
              ...plan,
              amount: ratePlan.price,
              cartInfo: {
                selected_number: ratePlan.quantity,
              },
              ratePlans: [],
              plan_code: 'mimic_' + plan.plan_code,
            });
          });
        }
      });
      const data = {
        mode,
        plans,
      };
      this.aware(data);
      return data;
    },
    mode() {
      return this.mimic.mode;
    },
  },
  render() {
    return <div>{this.$renderPrice(this.mimic.plans)}</div>;
  },
};

export default {
  data() {
    return {
      resolve_: null,
      visible_: false,
      plansCount: 1,
    };
  },
  computed: {
    ...mapGetters(['boughtPlans', 'getSelectedPlans']),
  },
  components: {
    PlanDetail,
    CurrentCharge,
  },
  methods: {
    planDetailAware({plans}){
      this.plansCount = plans.length;
    },
    $popup() {
      this.visible_ = true;
      this.$tracking.buyInteraction('product details', `${this.$attrs.trackingName} current plan details - impression`);
      return new Promise((resolve) => {
        this.resolve_ = resolve;
      });
    },
    afterClose(){
      this.$tracking.buyInteraction('product details', `${this.$attrs.trackingName} plan details - exit`);
    },
    onCancel() {
      this.visible_ = false;
      this.resolve_(false);
    },
    async onConfirm() {
      this.visible_ = false;
      this.resolve_();
    },
    currentChargeAmountModifier(list) {
      // HACK CurrentCharge > nextBill.amount > getSelectedPlans, we have to exclude the delta part
      const plan = plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).get(0); // this is edit flow
      return list.map((x) => {
        if(x.billingCycle === plan.billing_cycle){
          const deltaAmount = this.$refs.planDetail.mx_price_delta(plan);
          x.amount = x.amount - deltaAmount;
        }
        return x;
      });
    },
  },
};
</script>

<style lang="scss">
.opc-zod {
  font-family: Almaden Sans;
  &__head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dfdfe4;
    padding-bottom: 8px;
    margin-bottom: 12px;
    h2 {
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
      text-align: left;
      color: #131619;
    }
    span {
      font-size: 14px;
      font-weight: 500;
      line-height: 32px;
      text-align: right;
      color: #6e7680;
    }
  }
  .opc-cart-item{
    margin-bottom: 12px;
  }
  &__footer{
    padding-top: 12px;
    border-top: 1px solid #dfdfe4;
  }
}
</style>